import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import { Link, useHistory } from 'react-router-dom';
import { FiArrowLeftCircle, FiArrowRightCircle, FiSend } from 'react-icons/fi';
import { FaRegCommentAlt } from 'react-icons/fa';
import { AiFillLike } from 'react-icons/ai';
import api from '../../services/api';
import Header from '../Includes/Header';
import Nav from '../Includes/Filtros';
import TituloPagina from '../Includes/Titulos';
import Footer from '../Includes/Footer';
import { useTranslation } from 'react-i18next';

import './styles.css';
const USER_EMAIL = sessionStorage.getItem('email');
const USER_TOKEN = sessionStorage.getItem('token');
const BASE_URL = sessionStorage.getItem('BASE_URL');

export default function Mensagem(props) {
  const publicacao_id = props.match.params.id;
  const history = useHistory();

  const [mensagem, setMensagem] = useState('');
  const [tags, setTags] = useState(['']);
  const [TAGS, setTAGS] = useState(JSON.parse(sessionStorage.getItem('TAGS')));
  const [vetTag, setVetTag] = useState(['']);
  const { t } = useTranslation();

  async function carregaTags() {
    await api.get('/v4/tags', {
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,
        'Content-Type': 'application/json'
      }
    }).then(response => {
      sessionStorage.setItem("TAGS", JSON.stringify(response.data));
    });
  }

  carregaTags();

  useEffect(() => {
    const post = JSON.parse(sessionStorage.getItem('publicacao'));
    if(post.tags.length>0){
      //sessionStorage.setItem('tagsMsg', post.tags);
    }
    setMensagem(post.description);
    //sessionStorage.setItem('tagsMsg', post.tags);
    
    console.log(post);
    sessionStorage.setItem('tagsMsg', JSON.stringify(post.tags));
  }, [])

  async function enviarMenagem(e) {
    e.preventDefault();
    let tagsMsg = [];
    if (sessionStorage.getItem('tagsMsg') !== '') {
      JSON.parse(sessionStorage.getItem('tagsMsg')).forEach(el => {
        tagsMsg = [...tagsMsg, el.name]
      });
    }
    if (mensagem.length >= 2) {
      var axios = require('axios');
      var data = JSON.stringify({ "description": mensagem, "mentions": [], "tags": tagsMsg });

      var config = {
        method: 'put',
        url: BASE_URL + `/v4/users/me/posts/${publicacao_id}`,
        headers: {
          'USER_EMAIL': USER_EMAIL,
          'USER_TOKEN': USER_TOKEN,
          'Content-Type': 'application/json'
        },
        data: data
      };

      axios(config)
        .then(function (response) {
          console.log(response.data);
          history.push('/publicacoes');
        })
        .catch(function (error) {
        });

    }
  };
  function filtrar(arr, id) {
    var res = []
    for (var i = 0, j = arr.length; i !== j; i++) {
      if (arr[i].id !== id) res.push(arr[i]);
    }
    return res;
  }
  function verificaTag(tagsId) {
    let result = null;
    if (sessionStorage.getItem('tagsMsg')) {
      let vetTags = JSON.parse(sessionStorage.getItem('tagsMsg'));
      if (vetTags.length > 0) {
        result = JSON.parse(sessionStorage.getItem('tagsMsg')).find(tag => tag.id === tagsId);
      }
    }
    if (!result) {
      return 'tagOFF'
    } else {
      return 'tagON'
    }
  }

  function selecionaTag(tagsId) {
    if (sessionStorage.getItem('tagsMsg') !== '') {
      const resultTags = JSON.parse(sessionStorage.getItem('tagsMsg')).find(tag => tag.id === tagsId);
      if (resultTags) {
        const items = JSON.parse(sessionStorage.getItem('tagsMsg'));
        const valueToRemove = resultTags.id;
        const filteredItems = items.filter(item => item.id !== valueToRemove)
        sessionStorage.setItem('tagsMsg', JSON.stringify(filteredItems));
        history.push(`/publicacao/alterar/${publicacao_id}`);
        return false;
      }
    }


    let result = TAGS.find(tag => tag.id === tagsId);
    
    let vetTags = sessionStorage.getItem('tagsMsg') === '' ? [] : JSON.parse(sessionStorage.getItem('tagsMsg'));
    if (sessionStorage.getItem('tagsMsg') === '') {
      vetTags = [...vetTags, result];
    }
    
    if (vetTags.length > 7) {
      document.getElementById("mensagens").style.display = 'block';
      document.getElementById("mensagens").innerHTML = t('pages.publicationEdit.messages.maxOfTags');
      setTimeout(() => {
        document.getElementById("mensagens").innerHTML = "";
        document.getElementById("mensagens").style.display = 'none';
      }, 5000);
      return false;
    }
    const result2 = vetTags.find(tag => tag.id === tagsId);
    if (!result2) {
      vetTags = [...vetTags, result];
    }
    sessionStorage.setItem('tagsMsg', JSON.stringify(vetTags));
    history.push(`/publicacao/alterar/${publicacao_id}`);
  }
  return (
    <div className="mensagem-container">
      <Header />
      <Nav />
      <TituloPagina titulo={t('pages.publicationEdit.title')} />
      <section className="body">
        <ul>
          <li>

            <form className="formComent" onSubmit={enviarMenagem}>
              <div className="groupForm">
                <ul className="noGrid">
                  {
                    TAGS.map(tags => (
                      <li key={tags.id} rel={tags.id} className={verificaTag(tags.id)} onClick={() => selecionaTag(tags.id)}>
                        {tags.name}
                      </li>
                    ))
                  }
                </ul>
                <textarea wrap="hard" id="mensagem" name="mensagem" rows="4" cols="105"onChange={e => setMensagem(e.target.value)} value={mensagem}>{mensagem}</textarea>
                {/* <input className="mensagem" type="text"
                  value={mensagem}
                  onChange={e => setMensagem(e.target.value)}
                  placeholder="Escreva a mensagem"
                /> */}
                <button type="submit"><FiSend className="iconSend" /></button>
              </div>

            </form>
          </li>
        </ul>
        <div id="mensagens" className="msg erro">ESTA DIV É PARA MENSAGENS!!!</div>
      </section>
      <Footer />
    </div>
  )
}